export default __webpack_public_path__ + "static/media/Burdwan-University.af0b8aaa.png";